// This file is auto-generated by running `yarn generate:cwe-data` and should not be manually edited.

const latestCWE: number = 1395;

export default latestCWE;
